import { PatientContinuouslyUsedMedicineExtended, PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';

import { TableDataAccessor } from '@dreryk/react-components';

import { MedicineSafetyIndicatorsConfigResolver } from '~libs.shared.medicine';

export const MedicineSelectorTableDataAccessor: TableDataAccessor<
   PatientMedicine | PatientContinuouslyUsedMedicineExtended
> = (props) => {
   return <MedicineSafetyIndicatorsConfigResolver medicines={props.currentPage} />;
};
